import { render } from "./ChicagoMagSubscription.vue?vue&type=template&id=15f6fbd8&scoped=true"
import script from "./ChicagoMagSubscription.vue?vue&type=script&lang=js"
export * from "./ChicagoMagSubscription.vue?vue&type=script&lang=js"

import "./ChicagoMagSubscription.vue?vue&type=style&index=0&id=15f6fbd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f6fbd8"]])

export default __exports__